<app-table
    tableKey="dashboardOperationalReports"
    [gridData]="store.data.getWorks()"
    [hideCheckboxes]="true"
    [columns]="columns()"
    [translatePrefix]="prefix"
    [showClearFilter]="false"
    [showFilters]="false"
    [showSearchBar]="false"
    [rowsPerPageOptions]="[10, 25, 50]"
    [additionalFilter]="additionalFilter()"
    [refreshCallback]="store.api.getWorks"
    [refreshCallbackFragment]="fragment"
    [defaultSorters]="[{ column: 'dateFrom', direction: 'DESC' }]"
    (detailCallback)="detail($event)"
>
    <ng-template pTemplate="type" let-data="data">
        <div>{{ data ? ('service.operationalReport.type.' + data | translate) : '' }}</div>
    </ng-template>

    <ng-template pTemplate="clients" let-data="data">
        <div class="flex flex-wrap gap-x-small">
            @for (folder of data; track folder.id) {
                @if (folder.person) {
                    <app-user-chip
                        [user]="folder.person"
                        [renderType]="UserChipRenderTypeEnum.Client"
                        [renderDetails]="false"
                        [sortDetails]="true"
                    ></app-user-chip>
                }
            }
        </div>
    </ng-template>
</app-table>
